import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Breadcrumbs, Container, Typography } from "@mui/material";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import authorPaths from "../subject-page/paths";
import subjectPaths from "../class_page/paths";
import { modulesData } from "../author_page/modulesData";

import "./BreadcrumbsModulePage.css";

function getFullName(abbreviation, from) {
  for (const [key, value] of Object.entries(from)) {
    if (value === abbreviation) {
      return key;
    }
  }
  return abbreviation;
}

function findTitle(data, id, subject, author, path) {
  if (data[id] && data[id][subject] && data[id][subject][author]) {
    const module = data[id][subject][author].find((item) => item.path === path);
    return module ? module.title : null;
  }
  return null;
}

function BreadcrumbsModulePage({ moduleTitle }) {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  if (location.pathname.includes("/instruction") || location.pathname.includes("/about")) {
    return null;
  }

  const id = pathSegments[1];
  const subject = pathSegments[2];
  const author = pathSegments[3];
  const module = pathSegments[5];

  const subjectFullName = subject ? getFullName(subject, subjectPaths) : null;
  const authorFullName = author ? getFullName(author, authorPaths) : null;
  const moduleFullname = module
    ? moduleTitle || findTitle(modulesData, id, subject, author, module)
    : null;

  const crumbs = [
    subjectFullName && { name: subjectFullName, path: `/class/${id}/${subject}` },
    author && { name: authorFullName, path: `/class/${id}/${subject}/${author}/modules` },
    module && {
      name: moduleFullname,
      path: `/class/${id}/${subject}/${author}/modules/${module}`,
    },
  ].filter(Boolean);

  return (
    <Container maxWidth="lg" className="module-breadcrumbs">
      <Breadcrumbs aria-label="Навігація сторінкою" separator="›">
        <Link className="module-breadcrumbs__link" to="/home">
          <HomeRoundedIcon fontSize="small" />
          Головна
        </Link>
        {crumbs.map((crumb, index) =>
          index === crumbs.length - 1 ? (
            <Typography key={crumb.path} color="text.primary">
              {crumb.name}
            </Typography>
          ) : (
            <Link key={crumb.path} className="module-breadcrumbs__link" to={crumb.path}>
              {crumb.name}
            </Link>
          )
        )}
      </Breadcrumbs>
    </Container>
  );
}

export default BreadcrumbsModulePage;
